import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-wrapper',
  templateUrl: './dashboard-wrapper.component.html',
  styleUrls: ['./dashboard-wrapper.component.css']
})
export class DashboardWrapperComponent implements OnInit {
  subMenu = 'driver';
  isInspectionDot = false;

  constructor(
    private router: Router
  ) {
    console.log('state', this.router.getCurrentNavigation().extras.state);
    const state = this.router.getCurrentNavigation().extras.state;
    if (state && state.isMapper && Boolean(state.isMapper)) {
      this.onSelectSubMenu('mapper');
    }
  }

  ngOnInit() {
  }

  onSelectSubMenu(menu) {
    this.subMenu = menu;
    if (this.subMenu === 'driver') {
      this.isInspectionDot = false;
    }
  }

}
